import './WatchLink.scss'

import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import useRouter from '../hooks/useRouter'
import { toLocaleUrl } from '../utils/locale'

interface Props {
  programSlug: string
}

const WatchLink = ({ programSlug }: Props) => {
  const { t } = useTranslation()
  const { history } = useRouter()

  const handleClick = useCallback(() => {
    history.push(toLocaleUrl(`/program/${programSlug}/direct-play`))
    // eslint-disable-next-line
  }, [programSlug])

  return (
    <button className="WatchLink" onClick={handleClick}>
      {t('program.play')}
    </button>
  )
}

export default WatchLink
